import React, { useEffect } from "react";
import Loader from "../../components/shared/Loader";
import { CheckoutCommonFields } from "../../models/ReceivedOrder";

const ReviewPayment = (props) => {
    const {
        model,
        orderSubmit,
        customerOrderNumber,
        isSubmittingOrder,
        partnerMessage,
        termsAndConditionsInstructions,
        checkoutCommonFields,
        retrySubmit } = props;

    useEffect(() => {
        checkoutCommonFields.map(field => {
            model[field.FieldName] = field.Value;
        })

    }, []);

    const submit = () => {
        orderSubmit(model);
    }

    const isValid = (field) => {
        return !field.ErrorMessage || field.ErrorMessage.length === 0;
    }

    const getErrorMessage = (field) => {
        return field.ErrorMessage;
    }

    const getFieldValue = (field) => {
        if (field.FieldName === CheckoutCommonFields.PoInfoPoFileName) {
            const fileField = checkoutCommonFields.find(x => x.FieldName === CheckoutCommonFields.PoInfoPoFile);
            const href = `data:application/pdf;base64,${fileField.Value}`;

            return <a href={href} download={field.Value}>
                {field.Value}
            </a>;
        }

        return field.Value;
    }

    const renderReceivedCartOrderFields = () => {
        const sections = [];
        (checkoutCommonFields || []).filter(x => x.FieldName !== CheckoutCommonFields.PoInfoPoFile).map(field => {
            sections.push(
                <React.Fragment key={field.FieldName}>
                    <dl className="details-cell">
                        <dt className="fw-bold" >{field.FieldName}</dt>
                    </dl>
                    <dl className="details-cell d-flex flex-sm-row flex-column" >
                        <dt className="flex-grow-1 pr-4">
                            <div className={isValid(field) ? "" : "is-invalid"}>
                                {getFieldValue(field)}
                            </div>
                            <div id="validationServer03Feedback" className="invalid-feedback">
                                {getErrorMessage(field)}
                            </div>
                        </dt>
                    </dl>
                </React.Fragment>);
        });

        return sections;
    }

    const showSubmitButton = () => {
        return !customerOrderNumber || (!customerOrderNumber && retrySubmit);
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col user-details">
                    {!customerOrderNumber && <div className="details-grid">
                        {
                            renderReceivedCartOrderFields()
                        }
                    </div>}
                    {customerOrderNumber && <div className="details-grid">
                        {`Order ${customerOrderNumber} created!`}
                    </div>}
                </div>
            </div>
            {partnerMessage && partnerMessage.CheckoutNotes && partnerMessage.CheckoutNotes.length > 0 &&
                <div className="row my-4">
                    <div className="col">
                        <div className="panel">
                            <h4 className="mb-3">
                                Additional Notes
                            </h4>
                            <div dangerouslySetInnerHTML={{ __html: partnerMessage.CheckoutNotes }}></div>
                        </div>
                    </div>
                </div>
            }
            <div className="row my-4">
                <div className="col">
                    <div className="panel py-0 bg-smoke-gray border-0 instructions-wrapper"
                        dangerouslySetInnerHTML={{ __html: termsAndConditionsInstructions }}>
                    </div>
                </div>
            </div>
            <div className="row d-lg-none">
                <div className="col">
                    <div className="my-4">
                        {isSubmittingOrder && <div style={{ width: "100%", justifyContent: "center", display: "flex" }}><Loader /></div>}
                        {showSubmitButton() && <button disabled={isSubmittingOrder} type="button" className="btn btn-primary ml-sm-auto w-100"
                            onClick={submit}>
                            Place Order Now
                        </button>}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ReviewPayment;